export default `
mutation removeFromMyWishlist($campaign_id: ID!) { 
    removeFromMyWishlist(campaign_id:$campaign_id){ 
    removed
    campaign_id
    }
}
`;